import { http } from '@/core/services'
import { ICountryReportParams } from './interfaces'

export const getArticleReq = (
    countryCode: string,
    params: ICountryReportParams,
) => {
    return http.get<any>(`countries-reports/${countryCode}`, { params })
}
